<template>
	<section class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="出入库记录" name="list">
				<div class="content-box">
					<div class="operator">
						<div class="operator-col">
							<el-select v-model="type" size="mini" clearable placeholder="选择类型">
								<el-option
										v-for="item in options"
										:key="item.value"
										:label="item.label"
										:value="item.value">
								</el-option>
							</el-select>
						</div>
						<div class="operator-col">
							<storehouse-input v-model="filterStorehouse" placeholder="预留仓"></storehouse-input>
						</div>
						<div class="operator-col">
							<warehouse-input v-model="filterWarehouse"></warehouse-input>
						</div>
						<div class="operator-col">
							<hispickup v-model="filterHisDate" size="mini"></hispickup>
						</div>
						<div class="operator-col">
							<el-input
								size="mini"
								v-model="filterTableSearch"
								placeholder="商品名"
								suffix-icon="el-icon-search"
								clearable
							></el-input>
						</div>
					</div>
					<curd-table
						:has-delete="false"
						ref="listTable"
						:data-model="editorDataModel"
						:fields="tableFields"
						@doedit="handleEdit($event)"
						:kv-filter="kvFilter"
            :search-filter="filterTableSearch"
						:date-filter="filterHisDate"
					>
						<template slot="listOp" slot-scope="scope">
							<el-button size="mini" type="text" @click="goReserveTxInfo(scope.row._id)">详情</el-button>
						</template>
					</curd-table>
				</div>
			</el-tab-pane>
		</el-tabs>
	</section>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";
import StorehouseInput from "@/widgets/Inputs/StorehouseInput.vue";
import WarehouseInput from "@/widgets/Inputs/WarehouseInput.vue";
import FilterStorehouse from "@/mixins/Filter/FilterStorehouse.js";
import FilterWarehouse from "@/mixins/Filter/FilterWarehouse.js";

export default {
	components: {StorehouseInput, WarehouseInput},
	mixins: [CurdPage, Filters, FilterStorehouse, FilterWarehouse],
	data() {
		return {
			options: [
				{
					value: 20,
					label: '退库单'
				},
				{
					value: 21,
					label: '入库单'
				}
			],
			type: '',
			filterStorehouse: { field: "storehouse", value: null },
			filterWarehouse: { field: "warehouse", value: null },
			editorDataModel: "Reserve_transaction",
			tableFields: [
				{
					name: "show_id",
					sortable: "custom"
				},
				{
					name: "type",
					sortable: true
				},
				{
					name: "name",
					isTrans: false,
					sortable: false
				},
				{
					name: "warehouse",
					isTrans: true,
					sortable: "custom",
					isTag: true
				},
				{
					name: "storehouse",
					isTrans: true,
					sortable: "custom",
					isTag: true
				},
				{
					name: "created_user",
					isTrans: false,
					sortable: false
				},
				{
					name: "created_at",
					isTrans: false,
					sortable: "custom"
				},
			],
		};
	},
	methods: {
		goReserveTxInfo(id) {
			const { href } = this.$router.resolve({
				name: "Reserve-Tx-Info",
				params: {
					id: id,
					tab: "info",
				},
			});
			window.open(href, "_self");
		},
	},

	watch:{
		"filterStorehouse": {
			handler() {
				let val = this.filterStorehouse;
				if (val._id != null && val._id !== "") {
					this.$set(this.kvFilter, "storehouse", { k: "storehouse", t: "string", v: val._id });
				} else {
					this.$delete(this.kvFilter, "storehouse");
				}
			},
			immediate: true,
			deep: true,
		},

		"filterWarehouse": {
			handler() {
				let val = this.filterWarehouse;
				if (val._id != null && val._id !== "") {
					this.$set(this.kvFilter, "warehouse", { k: "warehouse", t: "string", v: val._id });
				} else {
					this.$delete(this.kvFilter, "warehouse");
				}
			},
			immediate: true,
			deep: true,
		},
		"type": {
			handler(newVal) {
				if (newVal != null && newVal !== "") {
					this.$set(this.kvFilter, "type", { k: "type", t: "int", v: newVal});
				} else {
					this.$delete(this.kvFilter, "type");
				}
			},
			immediate: true,
			deep: true,
		},
	}
};
</script>
<style lang="scss" scoped>
</style>
